import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";

import { useHistory } from "react-router-dom";

import { _isMobile } from "../commonFunctions";
import NotificationItem from "./NotificationItem";
import notificationToast from "./NotificationToast";
import { useNotification } from "../../contexts/NotificationContext";

import "./NotificationPanel.css";

// Skeleton loading component
const NotificationSkeleton = () => (
    <div className="notification-skeleton-item">
        <div className="notification-skeleton-avatar"></div>
        <div className="notification-skeleton-body">
            <div className="notification-skeleton-title"></div>
            <div className="notification-skeleton-meta"></div>
            <div className="notification-skeleton-message"></div>
        </div>
    </div>
);

export function normalizeSourceType(sourceType) {
    if (!sourceType) return "all";
    return String(sourceType).toLowerCase().replaceAll("/", "-").replaceAll("_", "-");
}

export const NOTIFICATION_TABS = {
    all: {
        id: 0,
        label: "All",
        backgroundColor: "#f9fafb",
        svgColor: "#cccccc",
        svg: (
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3">
                <path d="M120-80q-33 0-56.5-23.5T40-160v-520h80v520h600v80H120Zm440-334L280-578v258h560v-258L560-414ZM280-240q-33 0-56.5-23.5T200-320v-340q0-21 9.5-40t28.5-30l322-190 80 47-352 207 272 160 270-160q15-9 30.5-8.5T890-666q14 8 22 21.5t8 30.5v294q0 33-23.5 56.5T840-240H280Zm280-320L448-672l56-56 56 56 142-142 56 56-198 198Zm0 240h280-560 280Z" />
            </svg>
        ),
        hoverColor: "#f3f4f6",
    },
    finance: {
        id: 1,
        label: "Finance",
        backgroundColor: "#fefcf7",
        svgColor: "#f5c26b",
        svg: (
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3">
                <path d="M470-320h29v-32q28-4 47.5-23t19.5-49q0-26-20-43.5T500-496v-74q10 3 16.5 10t9.5 17l36-15q-7-21-24-33.5T500-608v-32h-30v31q-28 3-47.5 20.5T403-542q0 27 20.5 45t46.5 29v79q-16-5-27-17t-15-28l-35 15q8 28 28 46t49 22v31Zm30-70v-66q11 5 19.5 12t8.5 21q0 16-8 22.5T500-390Zm-30-119q-11-5-20-12t-9-21q0-14 9-20.5t20-8.5v62ZM320-200q-117 0-198.5-81.5T40-480q0-117 81.5-198.5T320-760h320q117 0 198.5 81.5T920-480q0 117-81.5 198.5T640-200H320Zm0-80h320q83 0 141.5-58.5T840-480q0-83-58.5-141.5T640-680H320q-83 0-141.5 58.5T120-480q0 83 58.5 141.5T320-280Zm160-200Z" />
            </svg>
        ),
        hoverColor: "#fdf5e7",
    },
    "vp-manager": {
        id: 2,
        label: "VP/Manager",
        backgroundColor: "#fdfaf5",
        svgColor: "#f3d4a6",
        svg: (
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3">
                <path d="M485-240Zm26 80H160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440v80q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32h245q4 21 10.5 41t15.5 39Zm209 80q-73-18-116.5-80T560-298v-102l160-80 160 80v102q0 76-43.5 138T720-80Zm0-84q38-18 59-55t21-79v-52l-80-40-80 40v52q0 42 21 79t59 55ZM480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm0-80q33 0 56.5-23.5T560-640q0-33-23.5-56.5T480-720q-33 0-56.5 23.5T400-640q0 33 23.5 56.5T480-560Zm0-80Zm240 363Z" />
            </svg>
        ),
        hoverColor: "#fbf0e2",
    },
    factory: {
        id: 3,
        label: "Factory",
        backgroundColor: "#f9fef9",
        svgColor: "#b5e3b2",
        svg: (
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3">
                <path d="M80-80v-481l280-119v80l200-80v120h320v480H80Zm80-80h640v-320H480v-82l-200 80v-78l-120 53v347Zm280-80h80v-160h-80v160Zm-160 0h80v-160h-80v160Zm320 0h80v-160h-80v160Zm280-320H680l40-320h120l40 320ZM160-160h640-640Z" />
            </svg>
        ),
        hoverColor: "#f2fbf1",
    },
    qc: {
        id: 4,
        label: "QC",
        backgroundColor: "#faf9ff",
        svgColor: "#e0d6ff",
        svg: (
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3">
                <path d="m358-488-97-96 42-42 54 54 100-100 42 42-141 142Zm426 368L532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z" />
            </svg>
        ),
        hoverColor: "#ede9ff",
    },
    logistics: {
        id: 5,
        label: "Logistics",
        backgroundColor: "#fcf7fa",
        svgColor: "#f7c2da",
        svg: (
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3">
                <path d="M160-120q-50 0-85-35t-35-85q0-26 10-49.5T80-330v-190h80v-240h320l188 443q6 14 9 28t3 29q0 58-41 99t-99 41q-41 0-75.5-21.5T413-200H273q-13 36-44 58t-69 22Zm560-40v-640h80v560h120v80H720Zm-560-40q17 0 28.5-11.5T200-240q0-17-11.5-28.5T160-280q-17 0-28.5 11.5T120-240q0 17 11.5 28.5T160-200Zm380 0q25 0 42.5-17.5T600-260q0-25-17.5-42.5T540-320q-25 0-42.5 17.5T480-260q0 25 17.5 42.5T540-200Zm-267-80h128q2-11 4.5-20.5T413-320h-90L206-440h-46v80q38 0 69 22t44 58Zm84-120h189L427-680H240v160l117 120Zm-34 80-18.5-19q-18.5-19-40-41.5t-40-41L206-440h-46 46l117 120h90-90Z" />
            </svg>
        ),
        hoverColor: "#ffeef8",
    },
    "pre-order": {
        id: 6,
        label: "Pre Order",
        backgroundColor: "#f6fbfb",
        svgColor: "#8fcfca",
        svg: (
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3">
                <path d="M200-80q-33 0-56.5-23.5T120-160v-560q0-33 23.5-56.5T200-800h168q13-36 43.5-58t68.5-22q38 0 68.5 22t43.5 58h168q33 0 56.5 23.5T840-720v167q-19-9-39-15t-41-9v-143h-80v120H280v-120h-80v560h252q7 22 16 42t22 38H200Zm280-560q17 0 28.5-11.5T520-680q0-17-11.5-28.5T480-720q-17 0-28.5 11.5T440-680q0 17 11.5 28.5T480-640Zm240 560q-83 0-141.5-58.5T520-280q0-83 58.5-141.5T720-480q83 0 141.5 58.5T920-280q0 83-58.5 141.5T720-80Zm67-105 28-28-75-75v-112h-40v128l87 87Z" />
            </svg>
        ),
        hoverColor: "#eaf6f5",
    },
    order: {
        id: 6,
        label: "Order",
        backgroundColor: "#fef7f7",
        svgColor: "#89b2f9",
        svg: (
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3">
                <path d="M160-160v-516L82-846l72-34 94 202h464l94-202 72 34-78 170v516H160Zm240-280h160q17 0 28.5-11.5T600-480q0-17-11.5-28.5T560-520H400q-17 0-28.5 11.5T360-480q0 17 11.5 28.5T400-440ZM240-240h480v-358H240v358Zm0 0v-358 358Z" />
            </svg>
        ),
        hoverColor: "#fff0f0",
    },
    gia: {
        id: 6,
        label: "GIA",
        backgroundColor: "#fef7f7",
        svgColor: "#fba869",
        svg: (
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3">
                <path d="M323-160q-11 0-20.5-5.5T288-181l-78-139h58l40 80h92v-40h-68l-40-80H188l-57-100q-2-5-3.5-10t-1.5-10q0-4 5-20l57-100h104l40-80h68v-40h-92l-40 80h-58l78-139q5-10 14.5-15.5T323-800h97q17 0 28.5 11.5T460-760v160h-60l-40 40h100v120h-88l-40-80h-92l-40 40h108l40 80h112v200q0 17-11.5 28.5T420-160h-97Zm217 0q-17 0-28.5-11.5T500-200v-200h112l40-80h108l-40-40h-92l-40 80h-88v-120h100l-40-40h-60v-160q0-17 11.5-28.5T540-800h97q11 0 20.5 5.5T672-779l78 139h-58l-40-80h-92v40h68l40 80h104l57 100q2 5 3.5 10t1.5 10q0 4-5 20l-57 100H668l-40 80h-68v40h92l40-80h58l-78 139q-5 10-14.5 15.5T637-160h-97Z" />
            </svg>
        ),
        hoverColor: "#fff0f0",
    },
    forwarder: {
        id: 6,
        label: "Forwarder",
        backgroundColor: "#fef7f7",
        svgColor: "#8ac977",
        svg: (
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3">
                <path d="M440-280q-7 0-12-4t-7-10q-14-42-34-70t-40-54q-20-26-33.5-54T300-540q0-58 41-99t99-41q58 0 99 41t41 99q0 40-13.5 68T533-418q-20 26-40 54t-34 70q-2 6-7 10t-12 4Zm0-112q9-14 18-26t17-23q23-30 34-50t11-49q0-33-23.5-56.5T440-620q-33 0-56.5 23.5T360-540q0 29 11 49t34 50q8 11 17 23t18 26Zm0-98q21 0 35.5-14.5T490-540q0-21-14.5-35.5T440-590q-21 0-35.5 14.5T390-540q0 21 14.5 35.5T440-490Zm0 370q-150 0-255-105T80-480q0-75 28.5-140.5t77-114q48.5-48.5 114-77T440-840q75 0 140.5 28.5t114 77q48.5 48.5 77 114T800-480v8l53-54 57 56-150 150-150-150 57-56 53 53v-7q0-116-82-198t-198-82q-116 0-198 82t-82 198q1 116 82.5 198T440-200q57 0 107-21.5t88-58.5l57 57q-49 48-113.5 75.5T440-120Zm0-420Z" />
            </svg>
        ),
        hoverColor: "#fff0f0",
    },
    courier: {
        id: 6,
        label: "Courier",
        backgroundColor: "#fef7f7",
        svgColor: "#f08f8f",
        svg: (
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3">
                <path d="M280-160q-50 0-85-35t-35-85H60l18-80h113q17-19 40-29.5t49-10.5q26 0 49 10.5t40 29.5h167l84-360H182l4-17q6-28 27.5-45.5T264-800h456l-37 160h117l120 160-40 200h-80q0 50-35 85t-85 35q-50 0-85-35t-35-85H400q0 50-35 85t-85 35Zm357-280h193l4-21-74-99h-95l-28 120Zm-19-273 2-7-84 360 2-7 34-146 46-200ZM20-427l20-80h220l-20 80H20Zm80-146 20-80h260l-20 80H100Zm180 333q17 0 28.5-11.5T320-280q0-17-11.5-28.5T280-320q-17 0-28.5 11.5T240-280q0 17 11.5 28.5T280-240Zm400 0q17 0 28.5-11.5T720-280q0-17-11.5-28.5T680-320q-17 0-28.5 11.5T640-280q0 17 11.5 28.5T680-240Z" />
            </svg>
        ),
        hoverColor: "#fff0f0",
    },
    // GM-6016: manufacturer non-compliance alerts for the Compliance team (source_type COMPLIANCE)
    compliance: {
        id: 7,
        label: "Compliance",
        backgroundColor: "#f5f7ff",
        svgColor: "#8b93f8",
        svg: (
            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3">
                <path d="m438-338 226-226-56-58-170 170-86-84-56 56 142 142Zm42 258q-139-35-229.5-159.5T160-516v-244l320-120 320 120v244q0 152-90.5 276.5T480-80Zm0-84q104-33 172-132t68-220v-189l-240-90-240 90v189q0 121 68 220t172 132Z" />
            </svg>
        ),
        hoverColor: "#eef0ff",
    },
};

const NotificationPanel = ({ isOpen, onClose, fullScreen = false }) => {
    const [activeTabId, setActiveTabId] = useState("all");
    const history = useHistory();
    const observerRef = useRef(null);
    const scrollContainerRef = useRef(null);

    // Use notification context
    const { notifications: notificationItems, setNotifications, unreadCount, setUnreadCount, isLoading, isLoadingMore, hasMore, markAsRead, markAllAsRead, fetchMoreNotifications, playNotificationSound, handleNotificationClick, handleActionButtonClick } = useNotification();

    useEffect(() => {
        if (!isOpen && !fullScreen) return;

        const handleKeyDown = (event) => {
            if (event.key === "Escape" && !fullScreen) {
                onClose && onClose();
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [isOpen, onClose, fullScreen]);

    // Callback ref for infinite scroll trigger - sets up observer when element mounts
    const loadMoreTriggerRef = useCallback(
        (node) => {
            // Disconnect previous observer if exists
            if (observerRef.current) {
                observerRef.current.disconnect();
            }

            if (!node || !hasMore || isLoadingMore) {
                return;
            }

            const observer = new IntersectionObserver(
                (entries) => {
                    if (entries[0].isIntersecting && hasMore && !isLoadingMore) {
                        fetchMoreNotifications();
                    }
                },
                {
                    root: scrollContainerRef.current,
                    rootMargin: "100px",
                    threshold: 0.1,
                },
            );

            observer.observe(node);
            observerRef.current = observer;
        },
        [hasMore, isLoadingMore, fetchMoreNotifications],
    );

    // // DEMO: Simulate WebSocket notification after 5 seconds
    // useEffect(() => {
    //     let timer = null;
    //     for (let i = 1; i <= 3; i++) {
    //         timer = setTimeout(() => {
    //             // Create a simulated notification that mimics a WebSocket message
    //             const simulatedNotification = {
    //                 id: Date.now(), // Unique ID
    //                 source_type: "order",
    //                 source_id: "TEST-001",
    //                 priority: "HIGH",
    //                 heading: "New Order Received",
    //                 text: `A new order #TEST-00${i} has been placed and requires your attention.`,
    //                 is_read: false,
    //                 timestamp: Date.now(),
    //                 primary_action: {
    //                     id: 94,
    //                     displayType: "NOTIFICATION",
    //                     label: "",
    //                     icon: null,
    //                     actionType: "REDIRECT",
    //                     url: "https://devportal.geniemode.com/quality-check/reportfabricV2/3029",
    //                     position: "PRIMARY",
    //                     params: {},
    //                     apiType: "",
    //                 },
    //                 actions: [],
    //             };

    //             // Add the notification to the list (mimicking WebSocket behavior)
    //             setNotifications((prev) => [simulatedNotification, ...prev]);

    //             // Increase unread count
    //             setUnreadCount((prev) => prev + 1);

    //             // Play notification sound (mimicking WebSocket behavior)
    //             playNotificationSound();

    //             // toast.success("New notification received", {
    //             //     position: "top-right",
    //             //     duration: 121212000,
    //             //     closeButton: true,
    //             //     // dismissible: false
    //             // });

    //             notificationToast({
    //                 item: simulatedNotification,
    //                 handleNotificationClick,
    //                 handleActionButtonClick,
    //             });

    //             console.log("🔔 Simulated WebSocket notification received:", simulatedNotification);
    //         }, 1000 * i);
    //     }

    //     return () => clearTimeout(timer);
    // }, [setNotifications, setUnreadCount, playNotificationSound, handleNotificationClick, handleActionButtonClick]); // Runs once on mount (setState functions are stable)

    const handleDismiss = (id) => {
        setNotifications((prev) => prev.filter((item) => item.id !== id));
    };

    const handleMarkAllAsRead = async () => {
        await markAllAsRead();
    };

    const tabList = useMemo(() => {
        return Object.entries(NOTIFICATION_TABS)
            .map(([key, tab]) => ({ key, ...tab }))
            .sort((a, b) => (a.id ?? 0) - (b.id ?? 0));
    }, []);

    const tabConfigs = tabList
        .map((tab) => {
            if (tab.key === "all") {
                return { ...tab, count: notificationItems?.length };
            }
            const count = notificationItems.filter((item) => normalizeSourceType(item.source_type) === tab.key).length;
            return { ...tab, count };
        })
        .filter((tab) => tab.key === "all" || tab.count > 0);

    const filteredNotifications = activeTabId === "all" ? notificationItems : notificationItems.filter((item) => normalizeSourceType(item.source_type) === activeTabId);

    const sortedNotifications = [...filteredNotifications].sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0));

    const hasUnreadNotifications = filteredNotifications.some((item) => !item.is_read);

    const groupedByDate = sortedNotifications.reduce((acc, item) => {
        const dateObj = new Date(item.timestamp);
        const dateKey = dateObj.toISOString().slice(0, 10); // YYYY-MM-DD
        if (!acc[dateKey]) {
            acc[dateKey] = { date: dateObj, items: [] };
        }
        acc[dateKey].items.push(item);
        return acc;
    }, {});

    const groupedEntries = Object.values(groupedByDate).sort((a, b) => b.date - a.date);

    const formatDateLabel = (dateObj) => {
        const today = new Date();
        const todayKey = today.toISOString().slice(0, 10);
        const yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
        const yesterdayKey = yesterday.toISOString().slice(0, 10);
        const currentKey = dateObj.toISOString().slice(0, 10);

        if (currentKey === todayKey) return "Today";
        if (currentKey === yesterdayKey) return "Yesterday";

        return dateObj.toLocaleDateString(undefined, {
            day: "numeric",
            month: "short",
            year: "numeric",
        });
    };

    if (!isOpen && !fullScreen) {
        return null;
    }

    const renderContent = () => (
        <>
            <header className="notification-panel-header">
                <div className="notification-panel-header-left">
                    <h2 className="notification-panel-title">Notifications</h2>
                </div>

                <div className="notification-panel-header-right">
                    {!fullScreen && (
                        <button type="button" className="notification-panel-close-button" aria-label="Close notifications" onClick={onClose}>
                            ×
                        </button>
                    )}
                </div>
            </header>

            <section ref={scrollContainerRef} className="notification-panel-list">
                <div className="notification-panel-tabs-wrapper">
                    <nav className="notification-panel-tabs">
                        {tabConfigs.map((tab) => (
                            <button key={tab.key} type="button" className={`notification-panel-tab${tab.key === activeTabId ? " notification-panel-tab--active" : ""}`} onClick={() => setActiveTabId(tab.key)}>
                                {tab.label}
                                {tab.count > 0 && <span className={`notification-panel-tab-badge${tab.key === activeTabId ? "" : " notification-panel-tab-badge--muted"}`}>{tab.count}</span>}
                            </button>
                        ))}
                    </nav>
                </div>

                {isLoading ? (
                    <>
                        <NotificationSkeleton />
                        <NotificationSkeleton />
                        <NotificationSkeleton />
                        <NotificationSkeleton />
                        <NotificationSkeleton />
                    </>
                ) : groupedEntries.length === 0 ? (
                    <div className="notification-panel-empty" style={{ padding: "20px", textAlign: "center", color: "#666" }}>
                        No notifications
                    </div>
                ) : null}

                {!isLoading &&
                    groupedEntries.map((group) => (
                        <div key={group.date.toISOString()} className="notification-panel-date-group">
                            <div className="notification-panel-date-label">{formatDateLabel(group.date)}</div>
                            {group.items.map((item) => (
                                <NotificationItem key={item.id} item={item} handleNotificationClick={handleNotificationClick} handleActionButtonClick={handleActionButtonClick} />
                            ))}
                        </div>
                    ))}

                {/* Infinite scroll trigger */}
                {!isLoading && hasMore && (
                    <div ref={loadMoreTriggerRef}>
                        <NotificationSkeleton />
                    </div>
                )}

                {/* Show loading skeleton when fetching more */}
                {!isLoading && isLoadingMore && !hasMore && (
                    <>
                        <NotificationSkeleton />
                        <NotificationSkeleton />
                    </>
                )}
            </section>

            {!fullScreen && (
                <section className="bs p10">
                    <div className="dF jcSb aiC">
                        {hasUnreadNotifications && (
                            <button type="button" className="notification-panel-mark-read" onClick={handleMarkAllAsRead}>
                                Mark all as read
                            </button>
                        )}
                        {!_isMobile() && (
                            <button
                                type="button"
                                className="notification-panel-action-button"
                                onClick={() => {
                                    onClose();
                                    history.push("/notifications");
                                }}
                            >
                                See all
                            </button>
                        )}
                    </div>
                </section>
            )}

            {fullScreen && hasUnreadNotifications && (
                <section className="notification-panel-footer-fullscreen">
                    <button type="button" className="notification-panel-mark-read" onClick={handleMarkAllAsRead}>
                        Mark all as read
                    </button>
                </section>
            )}
        </>
    );

    if (fullScreen) {
        return (
            <div className="notification-panel-fullscreen">
                <aside className="notification-panel-container notification-panel-container--fullscreen">{renderContent()}</aside>
            </div>
        );
    }

    return (
        <div className="notification-panel-backdrop" onClick={onClose}>
            <aside className="notification-panel-container fadeInRight" onClick={(e) => e.stopPropagation()}>
                {renderContent()}
            </aside>
        </div>
    );
};

export default NotificationPanel;
